import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput } from '@/_components';
import { InventoryCategoriesSelect } from '@/_pages/settings/inventory-categories/shared/components';

import type { InventoryKitFormSchema } from './schemas/inventory-kit';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<InventoryKitFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6"
            label="Name (required)"
            {...field}
            disabled={!isEditable}
            autoFocus={autoFocus}
          />
        )}
      />

      <FormField
        control={form.control}
        name="category"
        render={({ field }) => (
          <InventoryCategoriesSelect
            formItemClassName="col-span-12 sm:col-span-6"
            label="Category (required)"
            value={field.value}
            isClearable={false}
            onValueChange={(value) => {
              if (value) {
                form.setValue('category', value);
                field.onChange(value);
              }
            }}
            disabled={!isEditable}
          />
        )}
      />
    </>
  );
}
